import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export default function MagicLink() {
    return (
        <>
            <Helmet>
                <title>Magic Link</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1 p-4 pb-24 md:pb-6 md:p-6">
                {/* start: magic-link page */}
                <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                    <div
                        className="max-w-sm w-full text-center"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <img
                            src="/images/reya-avatar-DwVTKqWN.png"
                            alt="Reya"
                            className="w-32 h-32 rounded-full mx-auto mb-6 shadow-2xl border-4 border-card"
                            style={{ transform: "scale(1.02337)" }}
                        />
                        <h2 className="text-2xl font-bold text-foreground mb-2">Welcome back!</h2>
                        <p className="text-foreground/70 mb-8">
                            Tap below to return to your conversation with Reya
                        </p>
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                            Open Chat
                        </button>
                        <p className="text-xs text-muted-foreground mt-6 mb-2">
                            Redirecting in 6 seconds...
                        </p>
                        <button className="text-sm text-primary hover:text-primary/80 underline transition-colors">
                            Skip
                        </button>
                    </div>
                </div>
                {/* end: magic-link page */}
            </div>

        </>
    );
}

